module.exports = __webpack_public_path__ + "static/IMG-20200906-WA0023-fc62cd57f5e46c7d1f0a65817fca9594.jpg";